/**
 * @file src/pages/invoice-creation-wizard/useSaveDraft.js
 * @description React Query mutation hook for saving an invoice as draft.
 *
 * What changed:
 *  - Import from utils/invoiceApis → api/invoice.api.js
 *  - console.log/error removed
 *  - On success, invoice-side and dashboard query sources are invalidated
 *  - Callers handle feedback via toast
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { saveDraftInvoice } from "api/invoice.api";
import {
  invalidateDashboardSources,
  invalidateInvoiceSide,
} from "lib/cacheInvalidation";

export const useSaveDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => saveDraftInvoice(data),
    onSuccess: () => {
      invalidateInvoiceSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
